import { z } from "zod";
/**
 * enrein:// logical artifact URI (D-002, D-019).
 * Format: enrein://agency/{agencyId}/project/{projectId}/run/{runId}/artifact/{artifactName}
 */
export const ENREIN_URI_SCHEME = "enrein:";
const SEGMENT = "[^/]+";
const ARTIFACT_PATH = "(?:[^/]+(?:/[^/]+)*)";
export const EnreinArtifactUriSchema = z
    .string()
    .regex(new RegExp(`^enrein:\\/\\/agency\\/${SEGMENT}\\/project\\/${SEGMENT}\\/run\\/${SEGMENT}\\/artifact\\/${ARTIFACT_PATH}$`), "Expected enrein://agency/{agencyId}/project/{projectId}/run/{runId}/artifact/{artifactName}");
export function formatEnreinArtifactUri(parts) {
    const uri = `${ENREIN_URI_SCHEME}//agency/${parts.agencyId}/project/${parts.projectId}/run/${parts.runId}/artifact/${parts.artifactName}`;
    return EnreinArtifactUriSchema.parse(uri);
}
export function parseEnreinArtifactUri(uri) {
    const validated = EnreinArtifactUriSchema.parse(uri);
    const match = validated.match(/^enrein:\/\/agency\/([^/]+)\/project\/([^/]+)\/run\/([^/]+)\/artifact\/(.+)$/);
    if (!match) {
        throw new Error(`Invalid enrein URI: ${uri}`);
    }
    const [, agencyId, projectId, runId, artifactName] = match;
    return { agencyId: agencyId, projectId: projectId, runId: runId, artifactName: artifactName };
}
//# sourceMappingURL=artifact-uri.js.map